// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_lt-1";
export var quotedThread = "_lt-0";